import React from 'react'
import Label from 'components/general/Label';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';

export default function BioAnchors({ data }) {
    const { mirs_noc } = useUrlFriendlyToParameters()
    const data_id = `NOCProfile${mirs_noc}`
    return (
        <ul id="navigator" className="list-inline text-center p-1 bio-navigator">
            <li className="list-inline-item" >
                <a href="#mirs-table-noc-medallists"><Label data="HeaderMedalsCurrent" ocsLabel={true}/></a>
            </li>
            <li className="list-inline-item" >
                <a href="#GeneralInterest"><Label data="HeaderGeneralInterest" ocsLabel={true}/></a>
            </li>
            <li className="list-inline-item" >
                <a href="#Anthem"><Label data="HeaderAnthem" ocsLabel={true}/></a>
            </li>
            {data?.nocBio?.interest?.ocFlagBearer &&
                <li className="list-inline-item" >
                    <a href="#FlagBearer"><Label data="HeaderFlagBearer" ocsLabel={true}/></a>
                </li>
            }
            <li className="list-inline-item" >
                <a href="#Membership"><Label data="HeaderMembership" ocsLabel={true}/></a>
            </li>
            <li className="list-inline-item" >
                <a href="#Officials"><Label data="HeaderOfficials" ocsLabel={true}/></a>
            </li>
            <li className="list-inline-item" >
                <a href="#Participation"><Label data="HeaderParticipation" ocsLabel={true}/></a>
            </li>
            <li id="relatedNews" className="relatedNews list-inline-item" data-id={data_id}>
                <a href="#"><Label data="HeaderRelatedNews" ocsLabel={true}/></a>
            </li>
        </ul>
    )
}